module.exports = __webpack_public_path__ + "img/Certificate_11.1b6dc18d.jpg";